// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom_table {
  border-collapse: collapse;
  box-sizing: border-box;
}
.custom_table,
.custom_table td {
  cursor: pointer;
  background: white;
  border: 1px solid #e6e9ec;
}
.custom_table th {
  background-color: #f7f7f7;
  border: 1px solid #e6e9ec;
}
/* .custom_table td:hover {background-color:coral  !important ;} */

.custom_table td:hover {
  background-color: #f5a76a !important;
}
table.custom_table thead {
  position: sticky;
  top: 0;
  background-color: red;
  z-index: 1;
}


.custom_table .th1 {
  width: 5%;
}
.custom_table .th2 {
  width: 10%;
}






.responsive_table {
  border: 1px solid #ddd;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

.responsive_table caption {
  font-size: 1.5em;
  margin: 0.5em 0 0.75em;
}

.responsive_table tr {
  border: 1px solid #ddd;
  padding: 0.35em;
}

.responsive_table th,
.responsive_table td {
  padding: 0.625em;
  text-align: center;
  align-items: center;
}

.responsive_table th {
  font-size: 0.85em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

@media screen and (max-width: 600px) {
  .responsive_table {
    border: 0;
  }

  .responsive_table caption {
    font-size: 1.3em;
  }

  .responsive_table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .responsive_table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: 0.625em;
  }

  .responsive_table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 0.8em;
    text-align: right;
  }

  .responsive_table td::before {
   
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }

  .responsive_table td:last-child {
    border-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/Table.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA,kEAAkE;;AAElE;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,qBAAqB;EACrB,UAAU;AACZ;;;AAGA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;;;;;;;AAOA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".custom_table {\r\n  border-collapse: collapse;\r\n  box-sizing: border-box;\r\n}\r\n.custom_table,\r\n.custom_table td {\r\n  cursor: pointer;\r\n  background: white;\r\n  border: 1px solid #e6e9ec;\r\n}\r\n.custom_table th {\r\n  background-color: #f7f7f7;\r\n  border: 1px solid #e6e9ec;\r\n}\r\n/* .custom_table td:hover {background-color:coral  !important ;} */\r\n\r\n.custom_table td:hover {\r\n  background-color: #f5a76a !important;\r\n}\r\ntable.custom_table thead {\r\n  position: sticky;\r\n  top: 0;\r\n  background-color: red;\r\n  z-index: 1;\r\n}\r\n\r\n\r\n.custom_table .th1 {\r\n  width: 5%;\r\n}\r\n.custom_table .th2 {\r\n  width: 10%;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.responsive_table {\r\n  border: 1px solid #ddd;\r\n  border-collapse: collapse;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  table-layout: fixed;\r\n}\r\n\r\n.responsive_table caption {\r\n  font-size: 1.5em;\r\n  margin: 0.5em 0 0.75em;\r\n}\r\n\r\n.responsive_table tr {\r\n  border: 1px solid #ddd;\r\n  padding: 0.35em;\r\n}\r\n\r\n.responsive_table th,\r\n.responsive_table td {\r\n  padding: 0.625em;\r\n  text-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.responsive_table th {\r\n  font-size: 0.85em;\r\n  letter-spacing: 0.1em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n  .responsive_table {\r\n    border: 0;\r\n  }\r\n\r\n  .responsive_table caption {\r\n    font-size: 1.3em;\r\n  }\r\n\r\n  .responsive_table thead {\r\n    border: none;\r\n    clip: rect(0 0 0 0);\r\n    height: 1px;\r\n    margin: -1px;\r\n    overflow: hidden;\r\n    padding: 0;\r\n    position: absolute;\r\n    width: 1px;\r\n  }\r\n\r\n  .responsive_table tr {\r\n    border-bottom: 3px solid #ddd;\r\n    display: block;\r\n    margin-bottom: 0.625em;\r\n  }\r\n\r\n  .responsive_table td {\r\n    border-bottom: 1px solid #ddd;\r\n    display: block;\r\n    font-size: 0.8em;\r\n    text-align: right;\r\n  }\r\n\r\n  .responsive_table td::before {\r\n   \r\n    content: attr(data-label);\r\n    float: left;\r\n    font-weight: bold;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  .responsive_table td:last-child {\r\n    border-bottom: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
